import dayjs from 'dayjs';

export const autoFilledCheckInDate = dayjs().add(14, 'day');
export const autoFilledCheckOutDate = dayjs().add(15, 'day');
